module.exports = __webpack_public_path__ + "img/selected4-min.00d6a254.png";